import {Question} from './question';

export const LESSONS = ['MATH', 'KYRGYZ', 'RUSSIAN', 'PHYSICS', 'CHEMISTRY', 'BIOLOGY', 'ENGLISH', 'HISTORY'];
export const LANGUAGES = ['KG', 'RU'];

export class SubjectTest {
  _id: string;
  title: string;
  attempts: string;
  language: string;
  lesson: string;
  price: number;
  questions: Question[] = [];

  createdAt: Date;
  updatedAt: Date;
}
